import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSpecialOfferApi, deleteSpecialOfferApi, toggleSpecialOfferPublishedStateApi } from './specialOfferSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Datatable from '~/components/Datatable';

function SpecialOffer() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.shopSaga.specialOffer);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                width: '3rem',
            },
            {
                name: 'offer_type',
                selector: (row) => row.offer_type,
                sortable: true,
            },
            {
                name: 'from_time',
                selector: (row) => row.from_time,
                sortable: true,
            },
            {
                name: 'to_time',
                selector: (row) => row.to_time,
                sortable: true,
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        hasDelete={false}
                        row={row}
                        thunkFunc={deleteSpecialOfferApi}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchSpecialOfferApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-12">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default SpecialOffer;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
